import { sortDocuments } from './sortDocuments';

export const getLastTicketDocument = (ticket) =>
	sortDocuments(ticket?._stored_documents).at(-1);
